import FormInputCheckBox from './component.jsx'
export default FormInputCheckBox
